import React, { useState } from 'react';

const AddTeacher = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    employeeId: '',
    designation: 'Lecturer',
    department: 'Computer Science',
    qualification: '',
    experience: 0,
    salary: 0,
    joiningDate: '',
    phone: '',
    address: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would submit to an API
    console.log('Teacher created:', formData);
    alert('Teacher created successfully!');
    setFormData({
      name: '',
      email: '',
      password: '',
      employeeId: '',
      designation: 'Lecturer',
      department: 'Computer Science',
      qualification: '',
      experience: 0,
      salary: 0,
      joiningDate: '',
      phone: '',
      address: ''
    });
  };

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Add New Teacher</h1>
        
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="name" className="block text-gray-700 mb-2">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="Enter teacher's full name"
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-gray-700 mb-2">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="Enter email address"
                />
              </div>
              
              <div>
                <label htmlFor="password" className="block text-gray-700 mb-2">Password *</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="Enter password"
                />
              </div>
              
              <div>
                <label htmlFor="employeeId" className="block text-gray-700 mb-2">Employee ID *</label>
                <input
                  type="text"
                  id="employeeId"
                  name="employeeId"
                  value={formData.employeeId}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="Enter employee ID"
                />
              </div>
              
              <div>
                <label htmlFor="designation" className="block text-gray-700 mb-2">Designation *</label>
                <select
                  id="designation"
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                >
                  <option value="Professor">Professor</option>
                  <option value="Assistant Professor">Assistant Professor</option>
                  <option value="Lecturer">Lecturer</option>
                  <option value="Instructor">Instructor</option>
                  <option value="Head of Department">Head of Department</option>
                </select>
              </div>
              
              <div>
                <label htmlFor="department" className="block text-gray-700 mb-2">Department *</label>
                <select
                  id="department"
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                >
                  <option value="Computer Science">Computer Science</option>
                  <option value="Mathematics">Mathematics</option>
                  <option value="Physics">Physics</option>
                  <option value="Chemistry">Chemistry</option>
                  <option value="Biology">Biology</option>
                  <option value="English">English</option>
                  <option value="History">History</option>
                  <option value="Geography">Geography</option>
                  <option value="Economics">Economics</option>
                  <option value="Business Studies">Business Studies</option>
                </select>
              </div>
              
              <div>
                <label htmlFor="qualification" className="block text-gray-700 mb-2">Qualification *</label>
                <input
                  type="text"
                  id="qualification"
                  name="qualification"
                  value={formData.qualification}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="e.g. PhD in Computer Science"
                />
              </div>
              
              <div>
                <label htmlFor="experience" className="block text-gray-700 mb-2">Experience (Years) *</label>
                <input
                  type="number"
                  id="experience"
                  name="experience"
                  value={formData.experience}
                  onChange={handleChange}
                  required
                  min="0"
                  className="w-full p-2 border rounded"
                  placeholder="Enter years of experience"
                />
              </div>
              
              <div>
                <label htmlFor="salary" className="block text-gray-700 mb-2">Salary *</label>
                <input
                  type="number"
                  id="salary"
                  name="salary"
                  value={formData.salary}
                  onChange={handleChange}
                  required
                  min="0"
                  className="w-full p-2 border rounded"
                  placeholder="Enter salary amount"
                />
              </div>
              
              <div>
                <label htmlFor="joiningDate" className="block text-gray-700 mb-2">Joining Date *</label>
                <input
                  type="date"
                  id="joiningDate"
                  name="joiningDate"
                  value={formData.joiningDate}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                />
              </div>
              
              <div>
                <label htmlFor="phone" className="block text-gray-700 mb-2">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Enter phone number"
                />
              </div>
            </div>
            
            <div className="mb-6">
              <label htmlFor="address" className="block text-gray-700 mb-2">Address</label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows="3"
                className="w-full p-2 border rounded"
                placeholder="Enter address"
              ></textarea>
            </div>
            
            <div className="flex justify-end space-x-4">
              <a href="/admin/teachers" className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600 transition">
                Cancel
              </a>
              <button
                type="submit"
                className="bg-primary text-white px-6 py-2 rounded hover:bg-blue-700 transition"
              >
                Add Teacher
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddTeacher;